/* eslint-disable prettier/prettier */
import React from "react";

/*
Props : 
Status = 'online' , 'offline'
Children = text
*/

const WithdrawPillTags = ({ variant = "pending", children }) => {
  const pillType = {
    approved: "bg-green-200 text-green border border-none",
    pending: "border border-yellow-300 bg-yellow-100 text-yellow",
    cancel: "border border-gray-500 bg-gray-900 text-light_gray",
    reject: "border border-red-100 bg-pillColor-red text-red",
    
  };
  return (
    <span
      className={`border text-2xs px-12px pt-3px pb-5px capitalize rounded-xl ${
        variant in pillType
          ? pillType[variant]
          : "bg-pillColor-other border-primary text-secondary "
      }
      `}
    >
      {children}
    </span>
  );
};

export default WithdrawPillTags;
